import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { RestaurantEdgeSettingsPatch } from '@/api/types'
import { restaurantsApi } from '@/api/endpoints/restaurants'

export function useRestaurantEdgeSettings(restaurantId: number) {
  return useQuery({
    queryKey: ['restaurantEdgeSettings', restaurantId],
    queryFn: () => restaurantsApi.getEdgeSettings(restaurantId),
    staleTime: 0,
  })
}

export function useSaveRestaurantEdgeSettings(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: RestaurantEdgeSettingsPatch) =>
      restaurantsApi.putEdgeSettings(restaurantId, body),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: ['restaurantEdgeSettings', restaurantId],
      })
    },
  })
}
